import { render } from "./IndicatorModule.vue?vue&type=template&id=16db74bd"
import script from "./IndicatorModule.vue?vue&type=script&lang=js"
export * from "./IndicatorModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__